import * as React from 'react';
import * as styles from './Dialog.module.scss';
import { Button } from '@amzn/dvui/dist/Button';
import { Answer } from '../model/model';


interface AnswersListProps {
    submitAction: Function,
    answers: Answer[]
}

export const AnswerList: React.ComponentType<AnswersListProps> = props => {
    // Randomise order ascending and descending
    const shuffledAnswers = (Math.random() * 2 > 1) ?
        props.answers.slice(0) : props.answers.slice(0).reverse()
    const answers = shuffledAnswers.map((answer) => {
        return (
            <Button className={styles.option} onClick={() => props.submitAction(answer.answerId)}>
                {answer.label}
            </Button>
        )
    })
    return <div>{answers}</div>
}